import React from 'react';
import FontsDefault from '../../Assistant/DefaultStyle';

function OurServicesCard({ title }) {
  return (
    <div className={`${FontsDefault.defaultServicesCard}`}>
      <h1 className={`${FontsDefault.textBold}`}>{title}</h1>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        className='h-6 w-6'
        fill='none'
        viewBox='0 0 24 24'
        stroke='currentColor'
        strokeWidth={2}
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M15 19l-7-7 7-7'
        />
      </svg>
    </div>
  );
}

export default OurServicesCard;
